<template>
  <div v-if="!isPlacedAtBottom">
    <div class="textme" v-if="!submitted">
      <div class="step-wrapper" v-if="currentStep == 1">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="step-description"><div class="step-title">1</div> <span>What do you need help with? (Class, Exam, Homework, etc)</span></div>
          <div class="step-one-services">
            <div
              class="step-one-service"
              :class="{'active' : selectedServices.includes(service)}"
              v-for='(service, i) in services'
              :key="i"
              @click="toggleService(service)"
            >
              {{ service }}
            </div>
          </div>
          <a href="#step2" @click.prevent><div class="step-next-button" @click="moveNextStep">Next Step</div></a>
          <div class="step-indicator">
            <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
          </div>
        </div>
      </div>

      <div class="step-wrapper" v-if="currentStep == 2 && totalSteps === 3">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="step-description"><div class="step-title">2</div> <span>What course(s) do you need help with?</span></div>
          <div class="step-content">
            <input type="text" class="step-input-text" placeholder="Class Name (or Course Code)" v-model="courseName" />
          </div>
          <div class="step-next-button" @click="moveNextStep"><a href="#form-step">Next Step</a></div>
          <div class="step-indicator">
            <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
          </div>
        </div>
      </div>

      <div class="step-wrapper" v-if="currentStep == 3 && totalSteps === 3">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="last-step-description"><div class="step-title">3</div> <span><span class="step-description">Contact Information</span> <span class="step-description-light">*We will only email or text you about the quote</span></span></div>
          <div class="step-content">
            <div class="step-full-width">
              <input type="text" class="step-input-text" placeholder="First Name" v-model="fullName"/>
            </div>
            <div class="step-full-width">
              <div class="step-half-width">
                <input type="text" class="step-input-text" placeholder="Email Address" v-model="email"/>
              </div>
              <div class="step-half-width">
                <input type="text" class="step-input-text" placeholder="Phone Number" v-mask="'+1 (###) ###-####'" v-model="phoneNumber"/>
              </div>
            </div>
            <div class="step-description-light flex-row">
              Preferred method of contact?
                <input type="radio" id="email" name="preferred_contact_method" value="email" checked>
                <label for="email">Email</label>
                <input type="radio" id="phone" name="preferred_contact_method" value="phone">
                <label for="phone">Phone</label>
            </div>
          </div>
          <vue-recaptcha sitekey="6Le4DnUjAAAAAIIG8wF1MO4wluAWq6Zkk3dMDzux" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod"></vue-recaptcha>
          <a href="#thank-you"><div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;">Get an Instant Quote</div></a>
          <!-- <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;">Get an Instant Quote</div> -->
          <div class="step-indicator">
            <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
          </div>
        </div>
      </div>

      <div class="step-wrapper" v-if="currentStep == 2 && totalSteps === 4">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="step-description"><div class="step-title">2</div><span>How Many Weeks Remain in the Course?</span></div>
          <div class="step-content">
            <select class="step-two-week-selection" v-model="weeksRemained">
              <option value="" selected>Select</option>
              <option v-for="index in 26" :key="index">{{ index }}</option>
            </select>
          </div>
          <div class="step-next-button" @click="moveNextStep"><a href="#step3">Next Step</a></div>
          <div class="step-indicator">
            <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
          </div>
        </div>
      </div>

      <div class="step-wrapper" v-if="currentStep == 3 && totalSteps === 4">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="step-description"><div class="step-title">3</div><span>What course(s) do you need help with?</span></div>
          <div class="step-content">
            <input type="text" class="step-input-text" placeholder="Class Name (or Course Code)" v-model="courseName" />
          </div>
          <a href="#form-step"><div class="step-next-button" @click="moveNextStep">Next Step</div></a>
          <div class="step-indicator">
            <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
          </div>
        </div>
      </div>

      <div class="step-wrapper" v-if="currentStep == 4 && totalSteps === 4">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="last-step-description"><div class="step-title">4</div><span><span class="step-description">Contact Information</span> <span class="step-description-light">*We will only email or text you about the quote</span></span></div>
          <div class="step-content">
            <div class="step-full-width">
              <input type="text" class="step-input-text" placeholder="First Name" v-model="fullName" />
            </div>
            <div class="step-full-width">
              <div class="step-half-width">
                <input type="text" class="step-input-text" placeholder="Email Address" v-model="email" />
              </div>
              <div class="step-half-width">
                <input type="text" class="step-input-text" placeholder="Phone Number" v-mask="'+1 (###) ###-####'" v-model="phoneNumber" />
              </div>
            </div>
            <div class="step-description-light flex-row">
              Preferred method of contact?
                <input type="radio" id="email" name="preferred_contact_method" value="email" checked>
                <label for="email">Email</label>
                <input type="radio" id="phone" name="preferred_contact_method" value="phone">
                <label for="phone">Phone</label>
            </div>
          </div>
          <vue-recaptcha sitekey="6Le4DnUjAAAAAIIG8wF1MO4wluAWq6Zkk3dMDzux" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod"></vue-recaptcha>
          <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;"><a href="#thank-you">Get an Instant Quote</a></div>
          <!-- <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;">Get an Instant Quote</div> -->
          <div class="step-indicator">
            <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
            <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
            <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="textme" v-else>
      <div class="step-wrapper">
        <img :src="leftImage" class="step-left-image" />
        <div class="step-wrapper-right">
          <div class="step-description">
            <span>Thank You For Submitting a Quote Request!</span>
            <img :src="checkmark" class="checkmark-img" />
          </div>
          <div class="step-content">
            We have received your information and one of our customer service representatives will be reaching out right away. Please check your email and/or text messages and respond to get your affordable quote.
          </div>
          <div class="step-next-button" @click="startAgain">Get Another Instant Quote</div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="textme" v-if="!submitted">
      <div class="step-wrapper display-block" v-if="currentStep == 1">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="step-description"><div class="step-title">1</div><span>What do you need help with? (Class, Exam, Homework, etc)</span></div>
            <div class="step-one-services">
              <div
                class="step-one-service"
                :class="{'active' : selectedServices.includes(service)}"
                v-for='(service, i) in services'
                :key="i"
                @click="toggleService(service)"
              >
                {{ service }}
              </div>
            </div>
            <div class="step-next-button" @click="moveNextStep"><a href="#step1">Next Step</a></div>
            <div class="step-indicator">
              <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="step-wrapper display-block" v-if="currentStep == 2 && totalSteps === 3">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="step-description"><div class="step-title">2</div><span>What course(s) do you need help with?</span></div>
            <div class="step-content">
              <input type="text" class="step-input-text" placeholder="Class Name (or Course Code)" v-model="courseName" />
            </div>
            <div class="step-next-button" @click="moveNextStep"><a href="#step2">Next Step</a></div>
            <div class="step-indicator">
              <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="step-wrapper display-block" v-if="currentStep == 3 && totalSteps === 3">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="last-step-description"><div class="step-title">3</div><span><span class="step-description">Contact Information</span> <span class="step-description-light">*We will only email or text you about the quote</span></span></div>
            <div class="step-content">
              <div class="step-full-width">
                <input type="text" class="step-input-text" placeholder="First Name" v-model="fullName"/>
              </div>
              <div class="step-full-width">
                <div class="step-half-width">
                  <input type="text" class="step-input-text" placeholder="Email Address" v-model="email"/>
                </div>
                <div class="step-half-width">
                  <input type="text" class="step-input-text" placeholder="Phone Number" v-mask="'+1 (###) ###-####'" v-model="phoneNumber"/>
                </div>
              </div>
              <div class="step-description-light flex-row">
                Preferred method of contact?
                  <input type="radio" id="email" name="preferred_contact_method" value="email" checked>
                  <label for="email">Email</label>
                  <input type="radio" id="phone" name="preferred_contact_method" value="phone">
                  <label for="phone">Phone</label>
              </div>
            </div>
            <vue-recaptcha sitekey="6Le4DnUjAAAAAIIG8wF1MO4wluAWq6Zkk3dMDzux" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod"></vue-recaptcha>
            <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;"><a href="#thank-you">Get an Instant Quote</a></div>
            <!-- <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;">Get an Instant Quote</div> -->
            <div class="step-indicator">
              <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="step-wrapper display-block" v-if="currentStep == 2 && totalSteps === 4">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="step-description"><div class="step-title">2</div><span>How Many Weeks Remain in the Course?</span></div>
            <div class="step-content">
              <select class="step-two-week-selection" v-model="weeksRemained">
                <option value="" selected>Select</option>
                <option v-for="index in 26" :key="index">{{ index }}</option>
              </select>
            </div>
            <div class="step-next-button" @click="moveNextStep"><a href="#step2">Next Step</a></div>
            <div class="step-indicator">
              <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="step-wrapper display-block" v-if="currentStep == 3 && totalSteps === 4">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="step-description"><div class="step-title">3</div><span>What course(s) do you need help with?</span></div>
            <div class="step-content">
              <input type="text" class="step-input-text" placeholder="Class Name (or Course Code)" v-model="courseName" />
            </div>
            <div class="step-next-button" @click="moveNextStep"><a href="#step3">Next Step</a></div>
            <div class="step-indicator">
              <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="step-wrapper display-block" v-if="currentStep == 4 && totalSteps === 4">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="last-step-description"><div class="step-title">4</div><span><span class="step-description">Contact Information</span> <span class="step-description-light">*We will only email or text you about the quote</span></span></div>
            <div class="step-content">
              <div class="step-full-width">
                <input type="text" class="step-input-text" placeholder="First Name" v-model="fullName" />
              </div>
              <div class="step-full-width">
                <div class="step-half-width">
                  <input type="text" class="step-input-text" placeholder="Email Address" v-model="email" />
                </div>
                <div class="step-half-width">
                  <input type="text" class="step-input-text" placeholder="Phone Number" v-mask="'+1 (###) ###-####'" v-model="phoneNumber" />
                </div>
              </div>
              <div class="step-description-light flex-row">
                Preferred method of contact?
                  <input type="radio" id="email" name="preferred_contact_method" value="email" checked>
                  <label for="email">Email</label>
                  <input type="radio" id="phone" name="preferred_contact_method" value="phone">
                  <label for="phone">Phone</label>
              </div>
            </div>
            <vue-recaptcha sitekey="6Le4DnUjAAAAAIIG8wF1MO4wluAWq6Zkk3dMDzux" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod"></vue-recaptcha>
            <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;"><a href="#thank-you">Get an Instant Quote</a></div>
            <!-- <div class="step-next-button" @click="moveNextStep" style="margin-top: 10px;">Get an Instant Quote</div> -->
            <div class="step-indicator">
              <span class="step-indicator-dot active" @click="goToStep(1, true)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 1}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 1}" @click="goToStep(2, currentStep > 1)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 2}"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 2}" @click="goToStep(3, currentStep > 2)"></span>
              <span class="step-indicator-line" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4"></span>
              <span class="step-indicator-dot" :class="{'active' : currentStep > 3}" v-if="totalSteps === 4" @click="goToStep(4, currentStep > 3)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="textme" v-else>
      <div class="step-wrapper display-block">
        <div>
          <h3 class="m900 centered"> Still not sure if you <br> need a nerd? </h3>
          <p>Message us to learn more about what Nerds can do! Submit your mobile number, and we will text you back within seconds!</p>
        </div>
        <div>
          <img :src="leftImage" class="step-left-image" />
          <div class="step-wrapper-right">
            <div class="step-description">
              <span>Thank You For Submitting a Quote Request!</span>
              <img :src="checkmark" class="checkmark-img" />
            </div>
            <div class="step-content">
              We have received your information and one of our customer service representatives will be reaching out right away. Please check your email and/or text messages and respond to get your affordable quote.
            </div>
            <div class="step-next-button" @click="startAgain">Get Another Instant Quote</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stepLeftImg from '../assets/images/step-left-image.png'
import checkmarkImg from '../assets/images/checkmark.png'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha
  },
  props: {
    isPlacedAtBottom: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      leftImage: stepLeftImg,
      checkmark: checkmarkImg,
      services: ['Online Class', 'Assignment', 'Proctored Exam', 'Project', 'Online Test', 'Exam', 'Other'],

      totalSteps: 3,
      currentStep: 1,
      selectedServices: [],
      submitted: false,

      fullName: null,
      email: null,
      phoneNumber: null,
      courseName: null,
      weeksRemained: '',
      recaptchaVerification: false
    }
  },
  methods: {
    goToStep (value, isAvailable) {
      if (isAvailable) {
        this.currentStep = value
      }
    },
    verifyMethod () {
      this.recaptchaVerification = true
    },
    expiredMethod () {
      this.recaptchaVerification = false
    },
    renderMethod () {
      this.recaptchaVerification = false
    },
    errorMethod () {
      this.recaptchaVerification = false
    },
    toggleService (service) {
      var duplicatedServices = [...this.selectedServices]
      if (duplicatedServices.includes(service)) {
        duplicatedServices = duplicatedServices.filter(svc => svc !== service)
      } else {
        duplicatedServices.push(service)
      }

      if (duplicatedServices.includes('Online Class')) {
        this.totalSteps = 4
      } else {
        this.totalSteps = 3
      }

      this.selectedServices = duplicatedServices
    },
    moveNextStep () {
      if (this.currentStep === this.totalSteps) {
        if (!this.fullName || !this.email || !this.phoneNumber) {
          return
        }
        if (this.recaptchaVerification === false) {
          return
        }
        console.log('submit values')
        var data = ''
        if (this.totalSteps === 3) {
          data = JSON.stringify({
            fullName: this.fullName,
            email: this.email,
            phoneNumber: this.phoneNumber.replace(/[^0-9.]+/g, ''),
            courseName: this.courseName,
            currentURL: window.location.href,
            selectedServices: this.selectedServices.join(', ')
          })
        } else {
          data = JSON.stringify({
            fullName: this.fullName,
            email: this.email,
            phoneNumber: this.phoneNumber.replace(/[^0-9.]+/g, ''),
            courseName: this.courseName,
            currentURL: window.location.href,
            selectedServices: this.selectedServices.join(', '),
            weeksRemained: this.weeksRemained
          })
        }

        // Adwords tracking
        this.$gtag.reportConversion({
          send_to: 'AW-722872910/4zLHCOfKgNgBEM7U2NgC' // the custom tag to be reported
        })

        // Facebook pixel tracking
        this.$analytics.fbq.event('Lead')

        fetch('/.netlify/functions/sendQuoteMail', {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: data
        })
          .then(response => response.json())
          .then(json => {
            this.submitted = true
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        if (this.totalSteps === 3) {
          if (this.currentStep === 1) {
            if (this.selectedServices.length === 0) {
              return
            }
          }

          if (this.currentStep === 2) {
            if (!this.courseName) {
              return
            }
          }
        } else {
          // totalSteps = 4
          if (this.currentStep === 1) {
            if (this.selectedServices.length === 0) {
              return
            }
          }

          if (this.currentStep === 2) {
            if (!this.weeksRemained) {
              return
            }
          }

          if (this.currentStep === 3) {
            if (!this.courseName) {
              return
            }
          }
        }

        this.currentStep = this.currentStep + 1
      }
    },
    startAgain () {
      this.currentStep = 1
      this.totalSteps = 3
      this.submitted = false
      this.selectedServices = []
      this.fullName = null
      this.email = null
      this.phoneNumber = null
      this.courseName = null
      this.weeksRemained = ''
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  * {
    box-sizing: border-box;
  }
  .textme {
    position: relative;
    max-width: 800px;
    width: 100%;
    margin: 0 auto;

    .step-wrapper {
      padding: 15px 30px;
      background: #fdc719;
      border-radius: 8px;
      border: 1px dashed #000;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: relative;
      width: 100%;
      min-height: 280px;

      @media #{$mobile} {
        //background: #FABB0B;
        // background: #fdc719;
        padding: 20px;
        border: none;
        align-items: flex-start;
        border-radius: 0px;
      }
    }

    .display-block {
      display: block;
    }

    img.step-left-image {
      width: 220px;
      height: auto;
      position: absolute;
      left: -17px;

      @media #{$mobile} {display: none;}
    }

    .step-wrapper-right {
      margin-left: 250px;
      width: calc(100% - 250px);
      .last-step-description {
        display: flex;
        justify-content: space-between;
        > span {
          width: calc(100% - 30px);
          .step-description {
            margin: 0;
          }
        }
      }

      @media #{$mobile} {
        width: 100%;
        margin-left: 0px;
      }
    }

    .step-title {
      font-weight: bold;
      font-family: 'Kanit', sans-serif;
      font-size: 15px;
      line-height: 1.5;
      text-transform: uppercase;
      background: #009F0C;
      color: #fff;
      display: flex;
      width: 20px;
      height: 20px;
      align-items: center;
      justify-content: center;
      flex-basis: auto;
      border-radius: 4px;
      margin-top: 4px;
    }

    .step-description {
      font-family: 'Kanit', sans-serif;
      font-size: 22px;
      font-weight: 800;
      line-height: 1.2;
      letter-spacing: 0.3px;
      margin-bottom: 10px;
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #000;

      > span {
        width: calc(100% - 30px);
      }

      @media #{$lxs} {
        font-size: 20px;
        margin-bottom: 22px;
      }
    }

    .step-description-light {
      font-family: 'Kanit', sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 30px;
      letter-spacing: 0.3px;
    }

    .step-one-services {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      justify-content: flex-start;
      width: 100%;
    }

    .step-one-service {
      border-radius: 4px;
      border: 2px solid #000;
      font-family: 'Kanit', sans-serif;
      font-size: 14px;
      line-height: 28px;
      padding: 5px 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      min-width: 90px;
      text-align: center;
      cursor: pointer;
      color: #000;
    }

    .step-one-service.active {
      background: #000;
      color: #fff;
    }

    .step-next-button {
      border-radius: 4px;
      background: #009F0C;
      background: #0184BF;
      color: #fff;
      font-family: 'Kanit', sans-serif;
      font-size: 14px;
      line-height: 30px;
      cursor: pointer;
      font-weight: 400;
      text-align: center;
      padding: 5px;
      box-shadow: 4px 4px 0px 0px rgb(0 0 0 / 15%);
    }
    a .step-next-button {
      color: #fff;
      text-decoration: none;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    .step-next-button a {
      color: #fff;
      text-decoration: none;
      display: inline-block;
      width: 100%;
      height: 100%;
    }

    .step-indicator {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span.step-indicator-dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #fff;
      background: #BEBEBE;
    }

    span.step-indicator-dot.active {
      background: #009F0C;
      background: #0184BF;
    }

    span.step-indicator-line {
      width: 18px;
      margin: 0 3px;
      border: 1px dashed #fff;
    }

    span.step-indicator-line.active {
      border: 1px dashed #009F0C;
    }

    .step-content {
      margin-top: 10px;
      margin-bottom: 10px;
      font-family: Kanit, sans-serif;
      font-size: 16px;
      line-height: 28px;
    }

    input.step-input-text {
      padding: 5px 15px;
      font-size: 14px;
      width: 100%;
      border-radius: 4px;
      border: none;
      font-family: Kanit, sans-serif;
      line-height: 28px;
    }

    input.step-input-text:focus-visible {
      outline: none;
    }

    .step-full-width {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .step-half-width {
      width: calc(50% - 5px);
    }

    .flex-row {
      display: flex;
      align-items: center;

      input[type="radio"] {
        width: 16px;
        height: 16px;
        margin-top: 0;
      }
    }

    select.step-two-week-selection {
      width: 100%;
      border: 2px solid #00A300;
      border-radius: 4px;
      font-family: Kanit, sans-serif;
      font-size: 14px;
      line-height: 28px;
      padding: 5px 15px;
    }

    select.step-two-week-selection:focus-visible {
      outline: none;
    }
  }
</style>
